/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,ButtonModule,PaginatorModule,DropdownModule} from "primeng/primeng";

import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';
import {Certificate} from '../../model/certificate';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SearchModule} from "../../component/search.component";
import {SelectItem} from "primeng/components/common/api";
import {DatexPipe} from "../../pipe/datex.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Component({

selector: 'cert-management',
templateUrl: 'cert_management.html'
})
export class CertManagementComponent implements  OnInit{

  private certificate_list : Certificate[] = [];

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;


  constructor(private service:MamAdminService, private logger : Logger) {
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: '인증서 별칭', value: 'name'});
    this.searchIDs.push({label: '유효기간 종료일', value: 'notAfterDate'});

    this.dateIsTrue = false;
  }

  ngOnInit(): void {
    this.getCertList(1,10,'2016-09-12', '2017-02-13', "", '','');
  }
  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    this.getCertList(1,this.pageMax,'2016-09-12', '2017-02-13',this.searchText, "true", this.searchId);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {

      this.getCertList(event.page + 1, event.rows,'2016-09-12', '2017-02-13',this.searchText, "true", this.searchId);
    } else {

      this.getCertList(event.page + 1, event.rows,'2016-09-12', '2017-02-13',"", '',"");
    }

  }

  getCertList(page:number, max:number, start:string, end:string, search:string, like:string, field:string) {
    this.service.getCertificationList(page, max, start, end, search, like, field).subscribe(
        value => {
          this.table_list = value.rows;
          this.totalRecord = value.total;
          this.logger.debug("-- certificate_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  insertCertification(certModel:any) {
    this.service.insertCertification(certModel).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- insertCertification result :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  deleteCertification(id:number) {
    this.service.deleteCertification(id).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- deleteCertification result :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }
  addCert(event) {
    let cert = { };
    this.insertCertification(cert);
  }

  delCert(event) {
    var id = 0;
    this.insertCertification(id);
  }
}
@NgModule({
  imports: [DataTableModule,ButtonModule,HttpModule,BrowserModule, CommonModule,PaginatorModule,DropdownModule,FormsModule,SearchModule,MainPipeMoudle],
  exports: [CertManagementComponent],
  declarations: [CertManagementComponent],
  providers: [MamAdminService],
})
export class CertManagementModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/device/cert_management.ts